import { render } from "./App.vue?vue&type=template&id=583a5617"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=583a5617&lang=css"

import exportComponent from "D:\\Students\\서용석\\vuestudy\\vuegeoje\\vuegeoje\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__